<div class="item" [class.selected]="selected">
  <div class="content">
    <div class="address-info">
      <div class="icons">
        <sibat-typology-indicator [color]="color"></sibat-typology-indicator>
      </div>
      <div class="address">
        @if (building.addresses?.length > 0) {
        <h3>{{ building.addresses[0] }}</h3>
        } @else {
        <h3>{{ 'building.addressNotAvailable' | transloco }}</h3>
        }
      </div>
    </div>

    @if (attributesDisplay['municipality']) {
    <div class="inline-info">
      <div class="icons">
        <mat-icon class="icon-info">account_balance</mat-icon>
      </div>
      <p class="subline subline-truncated">{{ building.municipality }}</p>
    </div>
    }

    <div class="inline-info">
      <div class="icons">
        <mat-icon class="icon-info">corporate_fare</mat-icon>
      </div>
      @if (building.localizedAffectations?.length) {
      <p class="subline subline-truncated">
        {{ building.localizedAffectations | join }}
      </p>
      } @if (!building.localizedAffectations?.length) {
      <p class="subline">{{ 'building.affectationToDefine' | transloco }}</p>
      }
    </div>

    @if (attributesDisplay['buildingClass']) {
    <div class="inline-info">
      <div class="icons">
        <mat-icon class="icon-info">business</mat-icon>
      </div>
      <p class="subline subline-truncated">{{ building.buildingClass }}</p>
    </div>
    } @if (attributesDisplay['constructionPeriod']) {
    <div class="inline-info">
      <div class="icons">
        <mat-icon class="icon-info">date_range</mat-icon>
      </div>
      @if (building.period) {
      <p class="subline subline-truncated">
        {{ 'building.constructionPeriod' | transloco : { period: building.period } }}
      </p>
      } @if (!building.period) {
      <p>&nbsp;</p>
      }
    </div>
    } @if (building.tags?.length) {
    <div class="inline-info tags">
      <div class="icons">
        <mat-icon class="icon-info">local_offer</mat-icon>
      </div>
      <mat-chip-listbox>
        @for (tag of building.tags; track tag) {
        <sibat-tag [name]="tag" (delete)="removeTagFromSelectedBuilding(tag)"></sibat-tag>
        }
      </mat-chip-listbox>
    </div>
    }
  </div>

  <div class="buttons">
    @if (!selected && !isInSelectedList) {
    <button (click)="addBuilding(); $event.stopPropagation()" mat-icon-button>
      <mat-icon>add</mat-icon>
    </button>
    } @if (selected || isInSelectedList) {
    <button (click)="removeBuilding(); $event.stopPropagation()" mat-icon-button>
      <mat-icon>remove</mat-icon>
    </button>
    }
    <button (click)="displayBuildingLocation(); $event.stopPropagation()" mat-icon-button>
      <mat-icon>my_location</mat-icon>
    </button>
  </div>
</div>
